/* eslint-disable vue/html-indent */
<template>
  <div class="">
    <section class="title">
      <div class="header__text-box">
        <h1 class="heading-primary">
          <span class="heading-primary--main">Tags: {{ id }} </span>
        </h1>
      </div>
    </section>
    
    <section class="section-blog-card">
      <div class="row">
        <div
          v-for="(blog, value) in blogs_array"
          :key="value"
          class="col-1-of-3"
        >
          <BlogCard
            :title="blog.title | truncate(30, '...')"
            :slug="blog.slug_name"
            :content="blog.body | truncate(30, '...')"
            :datecreated="blog.date_created.seconds"
            :background-image="blog.coverImage"
            :tags="id"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BlogCard from "@/components/shared/BlogCard";
import {
  getFirebaseCollectionWhere,
  getFirebaseDocumentFromCollection,
  searchFirebaseCollectionInArray
} from "@/functions/firebase/base";
export default {
  name: 'Tags',
    components: {
    BlogCard
  },
  data () {
    return {
      id: null,
      blogs_ids: null,
      blogs_array: [],
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getBlogsByTags()

  },

  methods: {
    getBlogsByTags(tag) {
     searchFirebaseCollectionInArray(process.env.VUE_APP_DB_TAGS_POST, 'tags', this.id).then((result) => {
       this.blogs_ids = result
       return result
       }).then((result)=> 
       result.forEach((element) => 
       getFirebaseDocumentFromCollection(process.env.VUE_APP_DB_BLOGS, element).then((result)=> this.blogs_array.push(result.shift()))
       ))
    }
  }
}
</script>
